import React, { useEffect, useState } from 'react';
import { Login } from '@milkmoovement/common_cognito_package';
import { onCognitoUnlock } from '../../../auth/store/actions';
import { useDispatch } from 'react-redux';
import { getRegion } from '../../../../utils';
import { fetchRegionFromBackend } from '../../../../utils/regionConfig';

const LockPage = ({ onUnlock, onLogout }) => {
    const dispatch = useDispatch();
    const [region, setRegion] = useState(null);
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const fetchedRegion = await fetchRegionFromBackend();
                setRegion(fetchedRegion);
            } catch (error) {
                setRegion(getRegion(window.location.hostname));
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    const handleSucessfulLogin = async () => {
        dispatch(await onCognitoUnlock());
        await onUnlock();
    };

    // Show loading state while fetching region
    if (isLoadingRegion || !region) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <Login
            isLocked
            onSucessfulLogin={handleSucessfulLogin}
            onLogout={onLogout}
            metadata={{
                coreSystem: region,
            }}
        />
    );
};

export default LockPage;
